



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLPENDINGCUSTOMERSWITHCREATOR
// GETALLPENDINGCUSTOMERSWITHCREATOR


const GETALLPENDINGCUSTOMERSWITHCREATOR= createAsyncThunk(
  "getAllPendingCustomersWithCreator/getAllPendingCustomersWithCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPendingCustomersWithCreatorSlice = createSlice({
  name: "getAllPendingCustomersWithCreatorSlice",
  initialState: {
    getAllPendingCustomersWithCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPendingCustomersWithCreator: (state) => {
        state.getAllPendingCustomersWithCreator.loading = false
        state.getAllPendingCustomersWithCreator.error = false
        state.getAllPendingCustomersWithCreator.data = []
        state.getAllPendingCustomersWithCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPENDINGCUSTOMERSWITHCREATOR.fulfilled, (state, action) => {
      state.getAllPendingCustomersWithCreator = {
        ...state.getAllPendingCustomersWithCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPENDINGCUSTOMERSWITHCREATOR.pending, (state, action) => {
      state.getAllPendingCustomersWithCreator = {
        ...state.getAllPendingCustomersWithCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPENDINGCUSTOMERSWITHCREATOR.rejected, (state, action) => {
      state.getAllPendingCustomersWithCreator = {
        ...state.getAllPendingCustomersWithCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPendingCustomersWithCreatorAction = {
    GETALLPENDINGCUSTOMERSWITHCREATOR,
};

export { getAllPendingCustomersWithCreatorAction };
export default getAllPendingCustomersWithCreatorSlice.reducer;
export const {setInitialStateOfgetAllPendingCustomersWithCreator} = getAllPendingCustomersWithCreatorSlice.actions
